<template>
  <div class="container-fluid w-100" style="overflow: hidden">
    <navbar :title="$t('user_alert.alerts_title')"/>

    <div class="col-12 search-form px-3 mt-2">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <div class="row">
        <div class="col-sm-4">
          <span class="search-title">{{ $t('contracts.status') }}</span>
            <div class="form-check form-check-md">
                <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="open === '0'"
                    @change="open = $event.target.checked ? '0' : '1'"
                    id="onlyOpenCheckbox"
                />
                <label class="form-check-label" for="onlyOpenCheckbox">
                    {{ $t('contracts.only_open') }}
                </label>
            </div>
        </div>
      </div>
      <div class="col-sm-12 d-flex justify-content-end">
        <button
          class="btn btn-primary form-button"
          @click.stop="fetchAlerts"
        >
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </div>
      <Transition name="fade">
          <div v-if="results.length > 0" class="mt-2">
              <user-alert-list
                  :results="results"
                  @show="showAlert"
              />
          </div>
      </Transition>
      <user-alert-editor-modal
            :alert="alert"
            @close="alert = null"
            @alert-resolved="alertResolved"
      />
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
  </div>
</template>


<script>
import {restApi} from '../../mixins/RestApiMixin'
import {userHelper} from '../../mixins/UserMixin'
import UserAlertList from './UserAlertList'
import UserAlertEditorModal from './UserAlertEditorModal'
import UserAlert from '@/components/user/alert/UserAlert'
import Navbar from "@/components/utils/Navbar";
import {inject, toRaw} from "vue";

export default {
    name: 'UserAlerts',
    components: {Navbar, UserAlertEditorModal, UserAlertList},
    mixins: [restApi, userHelper],
    data: function () {
        return {
            open: 0,
            results: [],
            loading: true,
            alert: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    mounted: function () {
        this.fetchAlerts()
    },
    methods: {
        async fetchAlerts() {
            this.loading = true
            try {
                this.results = await UserAlert.fetch(this, parseInt(this.open) === 1)
            } catch (e) {
            }
            this.loading = false
        },
        showAlert: function (alert) {
            if (!alert.resolved_time) {
                this.alert = alert
            } else {
                this.showAlert(this.$t('user_alert.resolved_edit_error'))
            }
        },
        alertResolved() {
            this.alert = null
            this.fetchAlerts()
        }
    }
}
</script>
